import React, {Fragment, useEffect} from "react";

import AgreementsTable from "root/Tables/AgreementsTable";
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import {useChildModuleContext} from "root/Wieldy/ApplicationModules/Child/ChildModuleContext";

const AgreementsPageBody = ({child_uid}) => {

    const { showCommPlanModal, getCommunicationsPlansForAdoptee, commsPlanIsLoading, commsPlanData } = useChildModuleContext() ;

    const onClickCommunicationsPlan = ( props ) =>
    {
        showCommPlanModal ( props ) ;
    }

    useEffect(() => {
        if ( child_uid !== undefined )
        {
            getCommunicationsPlansForAdoptee ( child_uid ) ;
        }
    }, [child_uid]);

    const childHasCommunicationsPlan = () =>
    {
        return commsPlanData.length !== 0 ;
    }

    const noPlanStyle = {
        marginBottom: '15px',
        fontSize: 'large',
        textAlign: 'center',
        padding: '15px'
    }

    return (
        <Fragment>
            {commsPlanIsLoading === true && <SpinnerDiv/>}
            {commsPlanIsLoading === false && childHasCommunicationsPlan() === false &&
                <div style={noPlanStyle}>This child has no communications plan</div>}
            {commsPlanIsLoading === false && childHasCommunicationsPlan() === true &&
                <AgreementsTable data={commsPlanData} isLoading={commsPlanIsLoading} child_uid={child_uid} onClick={onClickCommunicationsPlan}/>}

        </Fragment>
    );
};

export default AgreementsPageBody;
